<template>
  <div class="reSuccess">
    <!-- h5 -->
    <div v-if="$store.state.isMobile">
      <img v-if="pageType" :src="require(pageType ? '../../assets/hx.png' : '../../assets/re_success.png')">
      <div class="reSuccessWbs" v-else>
        <!-- 江西书画院 -->
        <img src="../../assets/ticket/jxhy_logo.png" v-if="$route.query.museumCode == 218425" class="jxhyImg">
        <img src="../../assets/ticket/wbs1.png" v-else>
        <div class="text" v-if="reData.auditState != 0 && reData.auditState != 2">
          <div>您已预约成功！</div>
          <div class="resText">
            {{successEntryTip}}
          </div>
        </div>
        <div class="text" v-else>
          <div>{{reData.auditState == 0 ? '审核中' : '未通过审核'}}</div>
        </div>
      </div>
      <div class="itemCard">
        <div class="reTime" style="margin-bottom: 0.2rem">场馆名称<span>{{t_name}}</span></div>
        <div class="reTime">预约时间<span>{{reData.bookingDate}}&nbsp;{{reData.timeRange}}</span></div>
        <div v-if="!isFid || reData.orderType == 1 && (reData.auditState != 0 && reData.auditState != 2)">
          <div class="baseLine"></div>
          <div class="dateNow" v-if="qrCodeUseTime > 0 && !pageType">二维码有效时间：{{qrCodeUseTime}}s</div>
          <div class="dateNow" v-if="qrCodeUseTime <= 0 && !pageType" @click="reloadQrCode">刷新</div>
          <div id="qrcode" ref="qrcode" :class="qrCodeUseTime == 0 ? 'qrCodeTimeOut' : ''" v-show="!pageType"></div>
          <div :class="`buttonConfirm ${qrCodeUseTime == 0 ? 'timeOut' : ''}`" v-if="$store.state.isMobile && !pageType">{{qrCodeUseTime > 0 ? '待核销' : '已过期'}}</div>
        </div>
      </div>
      <personalCard v-for="(item, index) in personals" :key="item.card">
        <div slot="left" :class="`leftName ${item.personType == 3 ? 'childLeft' : ''}`">{{item.personName}}</div>
        <div slot="right" class="rightContent" v-if="item.personType != 3">
          <div class="detail">
            <span class="title">证件类型</span>
            <span class="name">{{getCardTypeName(item.cardType)}}</span>
          </div>
          <div class="detail">
            <span class="title">证件号码</span>
            <span class="name">{{item.cardNum}}</span>
          </div>
          <div class="detail">
            <span class="title">联系电话</span>
            <span class="name">{{item.phone}}</span>
          </div>
          <div class="detail" v-if="reData.belongNum && !fillChildrenInfo && !index">
            <span class="title">{{reData.orderType == 2 ? '携带儿童' : '团队人数'}}</span>
            <span class="name">{{reData.belongNum}}名</span>
          </div>
          <div class="showErCode" @click="showErCode(item)" v-if="isFid && reData.orderType == 2">查看核销码</div>
        </div>
        <div slot="right" class="rightContent" v-else>
          <div class="detail">
            <span class="title">年龄</span>
            <span class="name">{{item.age}}</span>
          </div>
          <div class="detail" v-if="item.cardNum">
            <span class="title">证件号码</span>
            <span class="name">{{item.cardNum}}</span>
          </div>
          <div class="detail">
            <span class="title">性别</span>
            <span class="name">{{item.gender == 1 ? '男' : '女'}}</span>
          </div>
          <div class="showErCode" @click="showErCode(item)" v-if="isFid && reData.orderType == 2">查看核销码</div>
        </div>
      </personalCard>
      <div class="buttonNormal" @click="toIndex">返回主页</div>
      <div class="personalErCode" v-if="showPersonalErCode">
        <div class="baseLine"></div>
        <div class="reTime" style="margin-left: 0.7rem">预约时间：{{reData.bookingDate}}&nbsp;{{reData.timeRange}}</div>
        <div style="font-size: 0.45rem; margin: 0.3rem 0">核销人：{{personalErCodeInfo.personName}}</div>
        <div class="dateNow" v-if="qrCodeUseTime > 0 && !pageType">二维码有效时间：{{qrCodeUseTime}}s</div>
        <div class="dateNow" v-if="qrCodeUseTime <= 0 && !pageType" @click="reloadQrCode">刷新</div>
        <div id="qrcode" ref="qrcode" :class="qrCodeUseTime == 0 ? 'qrCodeTimeOut' : ''" v-show="!pageType"></div>
        <div :class="`buttonConfirm ${qrCodeUseTime == 0 ? 'timeOut' : ''}`" v-if="$store.state.isMobile && !pageType">{{qrCodeUseTime > 0 ? '待核销' : '已过期'}}</div>
        <div class="codeBack" @click="showPersonalErCode=false">返回</div>
      </div>
    </div>
    <!-- pc -->
    <div v-else>
      <topBanner></topBanner>
      <div class="pcContent">
        <!-- <img src="../../assets/ticket/pc_re_s.png"> -->
        <div class="reSuccessWbs">
          <!-- 江西书画院 -->
          <img src="../../assets/ticket/jxhy_logo.png" v-if="$route.query.museumCode == 218425" class="jxhyImg">
          <img src="../../assets/ticket/wbs1.png" v-else>
          <div class="text" v-if="reData.auditState != 0 && reData.auditState != 2">
            <div>您已预约成功！</div>
            <div class="resText">
              {{successEntryTip}}<br/>
              如需核销二维码可在手机预约平台登录查看
            </div>
          </div>
          <div class="text" v-else>
            <div>{{reData.auditState == 0 ? '审核中' : '未通过审核'}}</div>
          </div>
        </div>
        <div class="pcItemCard">
          <div class="itemTitle" v-if="!$store.state.isMobile">预约信息</div>
          <div class="pc">
            <div class="reTime" style="margin-bottom: 20px">场馆名称<span>{{t_name}}</span></div>
            <div class="reTime">预约时间<span>{{reData.bookingDate}}&nbsp;（{{reData.timeRange}}）</span></div>
            <div class="line3">
              <div class="personals">
                <personalCard v-for="(item, index) in personals" :key="item.card" v-show="!$store.state.isMobile">
                  <div slot="left" class="leftName">{{item.personName}}</div>
                  <div slot="right" class="rightContent" v-if="item.personType != 3">
                    <div class="detail">
                      <span class="title">证件类型</span>
                      <span class="name">{{getCardTypeName(item.cardType)}}</span>
                    </div>
                    <div class="detail">
                      <span class="title">证件号码</span>
                      <span class="name">{{item.cardNum}}</span>
                    </div>
                    <div class="detail">
                      <span class="title">联系电话</span>
                      <span class="name">{{item.phone}}</span>
                    </div>
                    <div class="detail" v-if="reData.belongNum && !fillChildrenInfo && !index">
                      <span class="title">{{reData.orderType == 2 ? '携带儿童' : '团队人数'}}</span>
                      <span class="name">{{reData.belongNum}}名</span>
                    </div>
                  </div>
                  <div slot="right" class="rightContent" v-else>
                    <div class="detail">
                      <span class="title">年龄</span>
                      <span class="name">{{item.age}}</span>
                    </div>
                    <div class="detail" v-if="item.cardNum">
                      <span class="title">证件号码</span>
                      <span class="name">{{item.cardNum}}</span>
                    </div>
                    <div class="detail">
                      <span class="title">性别</span>
                      <span class="name">{{item.gender == 1 ? '男' : '女'}}</span>
                    </div>
                  </div>
                </personalCard>
              </div>
              <div class="qrcodeWarp" v-if="reData.auditState != 0 && reData.auditState != 2">
                <!-- <img :src="erCode"> -->
                <div id="qrcode2" ref="qrcode2"></div>
                <div class="erCodeText">扫码前往移动端</div>
              </div>
            </div>
          </div>
        </div>
        <div class="button3" @click="toIndex">返回主页</div>
      </div>
    </div>
  </div>
</template>

<script>
import personalCard from '../../components/common/personalCard'
import topBanner from '../../components/common/topBanner'
import QRCode from 'qrcodejs2'

var qrcode, qrCodeTime
export default {
  data() {
    return {
      reData: {
        date: '2021-04-14',
        time: '9:00 - 11:00',
      },
      nowData: {},
      erCode: '',
      personals: [],
      qrCodeUseTime: 5,
      cardTypes: [
        {name: '身份证', val: 1},
        {name: '社会保障卡', val: 8},
        {name: '护照（Passport）', val: 2},
        {name: '台胞证', val: 5},
        {name: '军官证', val: 6},
        {name: '外国人永居证', val: 7},
        {name: '港澳居民来往内地通行证', val: 3},
      ],
      pageType: '',
      t_name: '',
      isFid: true,
      showPersonalErCode: false,
      personalErCodeInfo: {},
      fillChildrenInfo: false
    };
  },

  components: {personalCard, topBanner},

  methods: {
    getCardTypeName(cardType) {
      const cardTypeItem = this.cardTypes.find((item) => {
        return item.val == cardType
      })
      return cardTypeItem ? cardTypeItem.name : ''
    },

    // 查看个人核销码
    showErCode(item) {
      this.showPersonalErCode = true
      this.personalErCodeInfo = item
      clearInterval(qrCodeTime)
      this.creatQrCode(item.id)
    },
    
    toIndex() {
      this.$router.replace(`/ticket/home?museumCode=${this.$route.query.museumCode}${this.$route.query.id ? `&id=${this.$route.query.id}` : ''}${this.$route.query.code ? `&code=${this.$route.query.code}` : ''}`)
    },

    getOrderDetail(id) {
      this.$ajax(`/api/ticket/front/order/detail?ticketOrderId=${id}`).then((res) => {
        this.t_name = res.data.ticketInfo.ticketName
        this.fillChildrenInfo = res.data.ticketInfo.fillChildrenInfo
        this.personals = res.data.peoples
        this.reData = res.data.ticketOrder
        this.reData.timeRange = res.data.ticketOrder.timeRange.replace(':00-', '-').substring(0,11)
        // 个人预约的pc端
        if (!(!this.isFid || this.reData.orderType == 1) && !this.$store.state.isMobile) {
          this.$nextTick(() =>{
            this.creatQrCode()
          })
        }
        if (!(!this.isFid || this.reData.orderType == 1)) return
        if (this.reData.orderType == 1 && this.isFid) {
          this.personalErCodeInfo.id = this.personals.find((item) =>{return !item.belongId}).id
        }
        this.$nextTick(() =>{
          this.creatQrCode()
        })
      })
    },

    creatQrCode() {
      if (this.$store.state.isMobile) { //h5端生成核销二维码
        this.$ajax(`/api/ticket/front/order/encrypt-info?orderId=${this.$route.query.orderId}${this.personalErCodeInfo.id ? `&peopleId=${this.personalErCodeInfo.id}` : ''}`).then((res) => {
          this.starTime()
          let text = `${location.origin}${location.pathname}#/ticket/writeOffPersonal?museumCode=${this.$route.query.museumCode}&encryptInfo=${res.data}`;
          qrcode = new QRCode(this.$refs.qrcode, {
            text: text, //页面地址 ,如果页面需要参数传递请注意哈希模式#
            width: 200,
            height: 200,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H,
          })
        })
      } else { //pc端生成扫码移动端的按钮
        let text = `${location.origin}${location.pathname}#/ticket/home?museumCode=${this.$route.query.museumCode}${this.$route.query.code ? `&code=${this.$route.query.code}` : ''}${this.$route.query.id ? `&id=${this.$route.query.id}` : ''}`;
        qrcode = new QRCode(this.$refs.qrcode2, {
          text: text, //页面地址 ,如果页面需要参数传递请注意哈希模式#
          width: 200,
          height: 200,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H,
        })
      }
    },

    starTime() {
      this.qrCodeUseTime = 120
      qrCodeTime = setInterval(() => {
        this.qrCodeUseTime --
      }, 1000)
    },

    reloadQrCode() {
      this.$nextTick(() =>{
        this.$refs.qrcode.innerHTML = ''
        this.creatQrCode()
      })
    },

    getOrderDetailByWrite(id) {
      this.$ajax(`/api/ticket/front/order/write-off-detail?ticketOrderId=${id}&phone=${this.$store.state.writePhone}&museumCode=${this.$route.query.museumCode}`).then((res) => {
        this.t_name = res.data.ticketInfo.ticketName
        this.fillChildrenInfo = res.data.ticketInfo.fillChildrenInfo
        this.personals = res.data.peoples
        this.reData = res.data.ticketOrder
        this.reData.timeRange = res.data.ticketOrder.timeRange.replace(':00-', '-').substring(0,11)
      })
    }
  },

  created() {
    this.isFid = !isNaN(Number(this.$route.query.museumCode)) ? true : false
    this.$route.query.resType ? this.pageType  = this.$route.query.resType : ''
    let date = new Date()
    this.nowData.date = date.getMonth() + 1 + '月' + date.getDate() + '日'
    let h = date.getHours();
    h = h < 10 ? '0' + h : h;
    let min = date.getMinutes();
    min = min < 10 ? '0' + min : min;
    let s = date.getSeconds();
    s = s < 10 ? '0' + s : s;
    this.nowData.time = `${h}:${min}`
    this.erCode = require('../../assets/erCode.png')
    this.pageType ? this.getOrderDetailByWrite(this.$route.query.orderId) : this.getOrderDetail(this.$route.query.orderId)
  },

  mounted() {
    // if (this.pageType) return
    // this.$nextTick(() =>{
    //   this.creatQrCode()
    // })
  },

  computed: {
    successEntryTip() {
      return this.$route.query.museumCode == 327887 ? '入场时请带有效证件' : '入场时请携带身份证件'
    }
  },

  watch: {
    qrCodeUseTime(val) {
      if (val == 0) {
        clearInterval(qrCodeTime)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .reSuccess{
    margin-bottom: 1rem;
    // img{
    //   padding: 1rem 0.5rem 0 0.5rem;
    //   width: 9rem;
    // }
    .reTime{
      font-size: 0.45rem;
      font-weight: 500;
      display: flex;
      align-items: center;
      span{
        font-size: 0.42rem;
        font-weight: normal;
        margin-left: 0.7rem;
      }
    }
    .dateNow{
      font-size: 0.65rem;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
      span{
        font-size: 0.55rem;
        font-weight: normal;
        margin-left: 0.9rem;
        font-weight: 500;
      }
    }
    .detail{
      .title{
        width: 1.7rem;
        display: inline-block;
        margin-right: 0.6rem;
      }
    }

    .itemCard{
      #qrcode{
        width: 6rem;
        height: 6rem;
        padding-top: 0.5rem;
        margin: auto;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .qrCodeTimeOut{
        opacity: 0.5
      }
    }
    .buttonConfirm{
      width: 6rem;
    }
    .timeOut{
      background-color: #eee;
      color: #333;
    }
    .showErCode{
      font-size: 0.4rem;
      line-height: 0.5rem;
      height: 0.5rem;
      width: 2.5rem;
      float: left;
      margin-right: 0.5rem;
      padding: 0.1rem 0.2rem;
      margin-top: 0.1rem;
      border-radius: 0.15rem;
      margin-top: 0.3rem;
    }
    .personalErCode{
      position: fixed;
      height: 100vh;
      width: calc(100vw - 1rem);
      margin: 0 0.5rem;
      background: #fff;
      top: 0;
      left: 0;
      padding-top: 1.3rem;
      z-index: 222;
      .codeBack{
        position: absolute;
        top: 0.4rem;
        left: 0.3rem;
        font-size: 0.4rem;
        border: 1px solid #00000082;
        border-radius: 0.1rem;
        padding: 0.06rem 0.2rem;
      }
      #qrcode{
        width: 5rem;
        margin: 0.5rem auto;
        margin-bottom: 1rem;
      }
    }
    // pc
    .pcContent{
      #qrcode2{
        width: 150px;
        height: 150px;
        margin: auto;
      }
      .baseLine2{
        margin: 0.2rem;
        margin-left: 0.8rem;
      }
      .erCodeText{
        font-size: 20px;
        margin-top: 0.1rem;
      }
      img{
        width: 100%;
        padding: 0;
      }
      .button3{
        margin: auto;
      }
      .pcItemCard{
        margin-top: 30px;
        img{
          width: 1.2rem;
          padding-top: 0.2rem;
        }
        .reTime{
          font-size: 24px;
          margin-left: 80px;
          span{
            font-size: 24px;
            margin-left: 36px;
          }
        }
        .pc{
          padding: 40px 0;
          background-color: #fff;
          border-radius: 0.05rem;
          .line3{
            margin: 0 80px;
            display: flex;
            position: relative;
            align-items: flex-start;
            justify-content: space-between;
          }
          .qrcodeWarp{
            position: absolute;
            right: 0;
            top: -80px;
          }
        }
      }
    }
  }
</style>
<style type="text/css" lang="scss">
  #qrcode{
    img{
      width: 100%;
      height: 100%;
    }
  }
  .reSuccess{
    .reSuccessWbs{
      text-align: left;
      margin: 1rem 0.5rem 0.8rem 0.5rem;
      width: 9rem;
      background: linear-gradient(90deg, #E6D7C7 0%, #F6F5F5 24.96%, #F6F5F5 39.92%, #DBC3A7 100%);
      height: 3.5rem;
      border-radius: 0.2rem;
      position: relative;
      img{
        width: 3.2rem;
        height: 3.2rem;
        position: absolute;
        top: 0.5rem;
        left: 0.8rem;
        object-fit: cover;
      }
      .jxhyImg{
        object-fit: contain;
        top: 0.25rem;
      }
      .text{
        position: absolute;
        font-size: 0.5rem;
        font-family: FZDBSJW;
        left: 4.5rem;
        top: 1.3rem;
        div:nth-child(1){
          margin-bottom: 0.2rem;
        }
        .resText{
          font-size: 0.35rem;
        }
      }
    }
    .childLeft{
      height: 2.6rem;
    }
    .pcContent{
      .reSuccessWbs{
        width: 100%;
        height: 220px;
        border-radius: 20px;
        line-height: 43px;
        margin: 0;
        img{
          width:200px;
          height: 200px;
          top: 32px;
          left: 300px;
        }
        .jxhyImg{
          top: 10px;
        }
        .text{
          top: 50px;
          left: 580px;
          font-size: 26px;
          div:nth-child(1){
            margin-bottom: 5px;
          }
          .resText{
            font-size: 20px;
          }
        }
      }
      .reTime{
        margin-left: 0.5rem;
      }
      .personalCard{
        margin: 40px 0;
        padding: 20px;
        width: 580px;
        &::after{
        width: 0.05rem;
        }
        .left, .right{
          font-size: 0.1rem;
          overflow: hidden;
        }
        .left{
          padding: 0 20px;
          padding-left: 0;
          width: 80px;
          min-height: 150px;
          max-height: 300px;
          max-width: 100px;
          margin: 20px 0;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 40px;
          &::after{
            width: 0.05rem;
            height: 100%;
            top: 0;
          }
          .leftName{
            font-size: 20px;
            max-width: unset;
            height: auto;
            line-height: 26px;
            display: flex;
            justify-content: center;
            margin: auto;
            writing-mode: vertical-lr;
            letter-spacing: 0.05rem;
          }
        }
        .right{
          width: 460px;
          padding: unset;
          margin-left: 0;
          .rightContent{
            width: 3rem;
            .detail{
              line-height: 45px;
              font-size: 20px;
              .title{
                margin-right: 30px;
                font-size: 24px;
                width: 100px;
                text-align: left;
              }
              .name{
                font-size: 20px;
              }
            }
          }
        }
      }
    }
  }
</style>

<style type="text/css">
  .reSuccess #qrcode2 img{
    width: 100%;
    height: 100%;
  }
</style>
